import store from '@/store';

export default (fieldList, id, parentKey) => {
    let parentValue = "";
    if (!fieldList || !id) return {};
    const findField = (fieldList, id, depth, shouldIncrementDepth) => {
        if (shouldIncrementDepth) {
            depth++;
        }
        for (let field of fieldList) {
            if (field.FieldId === id) {
                const parentCheck = !parentKey || parentKey === parentValue;
                if(parentCheck){
                    field.depth = depth;
                    return field;
                }
            }

            if (field.AvailableFieldList) {
                parentValue = field.FieldId;
                const subField = findField(field.AvailableFieldList, id, depth, false);
                if (subField) return subField;
            }

            if (field.Options) {
                for (const option of field.Options) {
                    if (option.AvailableFieldList) {
                        parentValue = field.FieldId;
                        const subField = findField(option.AvailableFieldList, id, depth, true);
                        if (subField) return subField;
                    }
                }
            }
        }
    };

    const field = findField(fieldList, id, 0, false);

    if (!field && store.getters.getDebugMode) {
        console.warn(
            "The expected field \x1B[1m%s\x1B[m was missing in the config template data.",
            id
        );
        return {};
    }
    return field;
};